import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  min-width: 0;
  margin-left: 0.5rem;
`

export const List = styled.ol`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 0.35rem;
  margin: 0;
  padding: 0;
  list-style: none;
  min-width: 0;
  overflow: hidden;
`

export const Item = styled.li`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  min-width: 0;
  font-size: 0.875rem;
  line-height: 1.3;
  color: ${({ theme }) => theme.colors.textMuted};
`

export const Separator = styled.span`
  color: ${({ theme }) => theme.colors.textMuted};
  opacity: 0.7;
  font-size: 0.75rem;
  user-select: none;
`

export const CrumbLink = styled(Link)`
  color: ${({ theme }) => theme.colors.textSecondary};
  text-decoration: none;
  white-space: nowrap;
  transition: color 0.15s ease;

  &:hover {
    color: ${({ theme }) => theme.colors.action.primary.bg};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.action.primary.bg};
    outline-offset: 2px;
    border-radius: 4px;
  }
`

export const CrumbCurrent = styled.span`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;

  @media (max-width: 768px) {
    max-width: 140px;
  }
`
